import { Button, Dialog, DialogActions, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface ErrorDialogProps {
  open?: boolean;
  title?: string;
  children?: ReactNode;
  buttonVisibility?: boolean;
  buttonLabel?: string;
  buttonAction?: () => void;
  contactSupportMessage?: string;
}

export const ErrorDialog = ({
  open = false,
  title = 'エラー',
  children = 'エラーが発生しました',
  buttonVisibility = true,
  buttonLabel = '閉じる',
  buttonAction = () => {},
  contactSupportMessage = 'このエラーが表示された方は、お手数をおかけしますがお問い合わせください'
}: ErrorDialogProps) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      maxWidth={'xs'}
    >
      <DialogTitle
        id="error-dialog-title"
        textAlign={'center'}
        fontSize={'18px'}
        fontWeight={'bold'}
        marginTop={'20px'}
      >
        {title}
      </DialogTitle>
      <DialogContentText id="error-dialog-description" paddingX={'24px'} marginBottom={'32px'}>
        <Typography marginBottom={'13px'} style={{ whiteSpace: 'pre-wrap' }}>
          {children}
        </Typography>
        <Typography className="text-primary" fontSize={'11px'} fontWeight={'bold'} margin={'0px'}>
          {contactSupportMessage}
        </Typography>
        {buttonVisibility ? (
          <DialogActions>
            <Button
              className="bg-primary"
              variant="contained"
              fullWidth
              onClick={() => buttonAction()}
              style={{ textAlign: 'center', marginTop: '24px', marginLeft: '36px', marginRight: '36px' }}
            >
              {buttonLabel}
            </Button>
          </DialogActions>
        ) : (
          <></>
        )}
      </DialogContentText>
    </Dialog>
  );
};

export default ErrorDialog;
